import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBeatsComponent } from './simple-icons-beats.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBeatsComponent ],
    exports:      [ SimpleIconsBeatsComponent ],
    bootstrap:    []
})
export class SimpleIconsBeatsModule {}
